import type { IOdds } from '@/interface/IOdds';
import type { SportType } from '@/interface/enum';
import { MarketType } from '@/interface/enum';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';

/**
 * MarketType that need to show live score
 *
 * Won't be affected by feature toggle
 */
const marketTypeNeedShowLiveScore = [
    MarketType.CorrectScore,
    MarketType.FH_CorrectScore,
    MarketType.TotalGoal,
];

export function getScore(isLive: boolean, odds: IOdds, sportType: SportType) {
    if (!isLive) return '';

    const { newBetTypeLiveScoreSportMarket } = useFeatureToggleStore();
    const shouldShowLiveScore = marketTypeNeedShowLiveScore.includes(odds.marketType)
        || newBetTypeLiveScoreSportMarket[sportType]?.includes(odds.marketGroup.id);

    if (shouldShowLiveScore) {
        return `[${odds.eventResult.liveHomeScore}:${odds.eventResult.liveAwayScore}]`;
    }

    return '';
}
